import { useDispatch, useSelector } from "react-redux";

import { SUBMIT_PHOTO_ID } from "@store/user/userActions";
import { RootEntity, RootState } from "@types-runway/state";
import { getIdentityVerificationStatus, User } from "@types-runway/user";

const useIdentityVerification = () => {
  const dispatch = useDispatch();
  const user = useSelector<RootState, RootEntity<User>>((state) => state.user);

  const submitPhotoId = (file: File) => {
    dispatch({ type: SUBMIT_PHOTO_ID, file });
  };

  return {
    status: getIdentityVerificationStatus(user.data),
    isSubmitting: user.isPending,
    error: user.error,
    success: user.success,
    submitPhotoId,
  };
};

export default useIdentityVerification;
